import {Component, HostBinding, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { AppService } from '@irb/app.service';
import { IrbFooterDialogEvents } from './IrbFooterDialogEvents';
import { NavigationEnd, Router} from '@angular/router';
import {IUserDetails} from '@irb/app.model';
import {AnalyticsService} from "@irb-common/analytics/analytics.service";

@Component({ standalone: false,
  selector: 'irb-common-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})

export class FooterComponent implements OnInit {

  showMMCDisclaimerLink = false;
  MMC_ADVISOR = false;
  now: Date = new Date();
  userDetails: any;
  homeDashboard= false;

  constructor(public as: AppService, private readonly router: Router, private ats: AnalyticsService) {
  }

  ngOnInit() {
    this.getRolesInit();

    if (this.router.url === '/models/model-market-center') {
      this.showMMCDisclaimerLink = true;
    }

    this.router.events.subscribe(e => {
      if (e instanceof NavigationEnd) {
        this.showMMCDisclaimerLink = e.url === '/models/model-market-center' ? true : false;
        this.homeDashboard = this.router.url === '/home' || this.router.url === '/';
        if (!this.userDetails)
          this.getRoles();
      }
    });
  }

  showFooterDialog() {   
    this.as.fireEvent(IrbFooterDialogEvents.SHOW_FOOTER_DIALOG);	
  }

  showMMCFooterDialog() {
    this.as.fireEvent(IrbFooterDialogEvents.SHOW_MMC_FOOTER_DIALOG);
  }

  getRolesInit() {
    setTimeout(() => {
      this.getRoles();
    }, 1000);
  }

  getRoles() {
    this.userDetails = this.as.getItem('IRB_APP_CONFIG') as IUserDetails;
    if (this.userDetails) {
      this.MMC_ADVISOR = !this.userDetails.isMMCAdmin && !this.userDetails.isModelProvider;
    }
  }

  download_adv() {
    this.ats.trackClickEvent("lc_mmc_ft_adv");
  }
}
